import { useTranslation } from "react-i18next";
import { AlertProps, PageSection } from "@inductiveautomation/ws-components";

import { PurchaseTestContactStepProps } from "../../Training.types";
import { getDialogStyles } from "../../_training.styles";

export const useTermsStep = ({
  isOpen,
  onClose,
  purchaseBarProps,
  acknowledged,
  setAcknowledged,
  crmContactId,
  certificationType,
  creditsAvailable,
  paymentMethod,
  inCooldownPeriod
}: PurchaseTestContactStepProps) => {
  const translationKeyPrefix =
    certificationType?.toLowerCase() === "gold"
      ? "training.actions.purchase_test.dialog.gold.steps.overview"
      : "training.actions.purchase_test.dialog.core.steps.overview";
  const { t } = useTranslation("translation", {
    keyPrefix: translationKeyPrefix,
  });

  const { classes } = getDialogStyles();

  const unlinkedAccount = !crmContactId?.length;
  
  const retrieveAlertProps = (): AlertProps | undefined => {
    if (unlinkedAccount) {
      return {
        id: "purchase-test-dialog-unlinked-account-alert",
        title: "",
        description: t("unlinked_account_alert"),
        variant: "warning",
        closeButtonEventHandler: () => undefined,
      };
    }

    if(inCooldownPeriod){
      return {
        id: "purchase-test-dialog-unlinked-account-alert",
        title: t("test_limit_reached_alert_heading"),
        description: t("test_limit_reached_alert_description"),
        variant: "error",
        closeButtonEventHandler: () => undefined,
      };
    }

    if (creditsAvailable?.length) {
      if (
        certificationType === "CORE" ||
        (certificationType === "GOLD" && paymentMethod === "USE_CREDIT")
      ) {
        return {
          id: "purchase-test-dialog-free-test-alert",
          title: "",
          description: t("alert_free_cert_description"),
          variant: "info",
          closeButtonEventHandler: () => undefined,
        };
      }
    }
    return undefined;
  };

  return {
    label: t("label"),
    nextDisabled: !acknowledged || unlinkedAccount || inCooldownPeriod,
    substeps: [],
    hideSidebar: true,
    dialogProps: {
      supportingText: t("supporting_text"),
      isOpen,
      testId: "purchase-test-dialog-overview",
      showCloseButton: true,
      onClose,
      overline: "",
      headline: t("heading"),
      alert: retrieveAlertProps(),
      contentArea: (
        <div className={classes.purchaseTestOverviewContent}>
          <PageSection
            heading={t("content_heading_1")}
            description={t("content_description_1")}
            children={null}
          />
          <PageSection
            heading={t("content_heading_2")}
            description={[
              t("content_description_2"),
              t("content_description_2.1"),
            ]}
            children={null}
          />
          {certificationType == "CORE" && (
            <PageSection
              heading={t("content_heading_3")}
              description={t("content_description_3")}
              children={null}
            />
          )}
          <PageSection
            heading={t("content_heading_4")}
            description={t("content_description_4")}
            children={null}
          />
        </div>
      ),
      purchaseBarProps,
      helper: {
        checked: acknowledged,
        helperConfirmLabel: t("helper_confirm_label"),
        onCheckboxChange: setAcknowledged,
      },
    },
  };
};
